import SupportIcon from 'assets/svg/Icon-menu_support.svg';
import KbIcon from 'assets/svg/Icon-menu_layout.svg';
import ChangelogIcon from 'assets/svg/Icon-menu_changelog.svg';

export const getMenuIcon = (name) => {
  switch (name) {
    case 'support':
      return SupportIcon;
    case 'kb':
      return KbIcon;
    case 'changelog':
      return ChangelogIcon;

    default:
      break;
  }
};
